export default {
      id: "rebate-rounded-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#rebate-rounded",
      toString: function () {
        return this.url;
      }
    }